export default function Footer() {
  const footerLinks = [
    {
      title: '快速导航',
      links: [
        { label: '爆料合集', href: '#index' },
        { label: '视频速递', href: '#media' },
        { label: '热度榜单', href: '#ranking' },
        { label: '常见问答', href: '#faq' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '平台特色', href: '#features' },
        { label: '最新动态', href: '#updates' },
        { label: '投稿通道', href: '#contact' },
      ],
    },
    {
      title: '合作伙伴',
      links: [],
    },
  ];

  return (
    <footer id="footer" className="bg-secondary-50 border-t border-secondary-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="sm:col-span-2 lg:col-span-1">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 mb-3 cursor-pointer"
              >
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 font-bold text-lg">
                  瓜
                </span>
                <span className="font-heading text-xl text-foreground-900 whitespace-nowrap">
                  每日大瓜
                </span>
              </a>
              <p className="text-sm text-foreground-500 leading-relaxed mt-3">
                每日爆料吃瓜第一站，聚焦娱乐爆料、网友爆料与吃瓜每日新鲜感。整合全网猛料，文字截图摘要一网打尽。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-foreground-800 mb-4">
                  {group.title}
                </h4>
                {group.links.length > 0 ? (
                  <ul className="space-y-2">
                    {group.links.map((link) => (
                      <li key={link.label}>
                        <a
                          href={link.href}
                          onClick={(e) => {
                            e.preventDefault();
                            document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                          }}
                          className="text-sm text-foreground-500 hover:text-accent-600 transition-colors cursor-pointer"
                        >
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-sm text-foreground-400">敬请期待</p>
                )}
              </div>
            ))}
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 每日大瓜 · 娱乐爆料聚合平台 · 仅供参考，不构成事实认定
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-foreground-400 hover:text-accent-600 transition-colors cursor-pointer">回到顶部</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}